"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnePerJoule = exports.OnePerMegajoule = exports.OnePerKilojoule = exports.OnePerTherm = exports.OnePerMegaBtu = exports.OnePerBtu = exports.OnePerKiloWattHour = void 0;
var uom_1 = require("uom");
exports.OnePerKiloWattHour = uom_1.UnitFormat.createUnitFormat("/kWh", 2);
exports.OnePerBtu = uom_1.UnitFormat.createUnitFormat("/BTU", 2);
exports.OnePerMegaBtu = uom_1.UnitFormat.createUnitFormat("/MMBTU", 2);
exports.OnePerTherm = uom_1.UnitFormat.createUnitFormat("/Therm", 2);
exports.OnePerKilojoule = uom_1.UnitFormat.createUnitFormat("/kJ", 2);
exports.OnePerMegajoule = uom_1.UnitFormat.createUnitFormat("/MJ", 0);
exports.OnePerJoule = uom_1.UnitFormat.createUnitFormat("/J", 2);
//# sourceMappingURL=dimensionless-per-energy-format.js.map